/**
 * Appends the given data object as query parameters to the given URLSearchParams object
 * @param {URLSearchParams} params The URLSearchParams object to append the data to
 * @param {Object} data The data to append to the URLSearchParams object
 * @returns {URLSearchParams} The URLSearchParams object with the data appended
 */
export function appendSearchParams(params, data) {
    Object.entries(data)
        .filter(([, value]) => !!value && value?.length !== 0)
        .forEach(([key, value]) => {
            if (Array.isArray(value)) {
                // arrays are added as multiple parameters with the same key
                value.forEach((v) => params.append(key, v));
            } else {
                params.append(key, value);
            }
        });
    return params;
}
